/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["abbr[_ngcontent-%COMP%]{font-weight:700;font-style:italic}app-vehicle-service-details-tabs[_ngcontent-%COMP%], app-vehicle-service-grid[_ngcontent-%COMP%]{height:100%}"];
export { styles as styles };
